<template>
	<v-container>
		<v-card>
			<v-card-title>
				<strong><translate>Adyen Notifications</translate></strong>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col>
						<model-backend-table
							endpoint="/api/v0/adyennotifications"
							:headers="tableHeaders"
							:items-per-page-options="[ 25, 50, 100, ]"
						>
							<template #item.live="{ item }">
								{{ item.live ? true : false }}
							</template>
							<template #item.success="{ item }">
								{{ item.success ? true : false }}
							</template>

							<template #item.amount="{ item }">
								{{ transformToCurrency(item.amount) }}
							</template>
						</model-backend-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'AdyenNotificationOverview',
	data () {
		return {
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('id'), value: 'id', sortable: false,
				},
				{
					title: this.$gettext('Merchant Reference'), value: 'merchantReference', sortable: false,
				},
				{
					title: this.$gettext('psp Reference'), value: 'pspReference', sortable: false,
				},
				{
					title: this.$gettext('Reason'), value: 'reason', sortable: false,
				},
				{
					title: this.$gettext('amount'), value: 'amount', sortable: false,
				},
				{
					title: this.$gettext('Event Code'), value: 'eventCode', sortable: false,
				},
				{
					title: this.$gettext('Event Date'), value: 'eventDate', sortable: false,
				},
				{
					title: this.$gettext('success'), value: 'success', sortable: false,
				},
				{
					title: this.$gettext('live'), value: 'live', sortable: true,
				},
			];
		}
	},
	methods: {
		/**
		 * @param {string} amount
		 * @returns {string}
		 */
		transformToCurrency (amount) {
			const eurFormatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'EUR',
			});

			return eurFormatter.format(Number(amount));
		},
	},
};

</script>

<style scoped>

</style>
